import { render, staticRenderFns } from "./RequestToken.vue?vue&type=template&id=50fe859c&scoped=true&lang=html&"
import script from "./RequestToken.vue?vue&type=script&lang=js&"
export * from "./RequestToken.vue?vue&type=script&lang=js&"
import style0 from "./RequestToken.vue?vue&type=style&index=0&id=50fe859c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe859c",
  null
  
)

export default component.exports